import { UserHierarchyLevel } from '../enums/user.enums';

export interface RouteConfig {
	path: string;
	label: string;
	minLevel: UserHierarchyLevel;
	icon?: string;
}

export const FARMER_ROUTES: RouteConfig[] = [
	{ path: '/', label: 'Home', minLevel: UserHierarchyLevel.Farmer, icon: 'home' },
	{
		path: '/dashboard',
		label: 'Dashboard',
		minLevel: UserHierarchyLevel.Farmer,
		icon: 'dashboard',
	},
	{ path: '/flora-ai', label: 'Flora AI', minLevel: UserHierarchyLevel.Farmer, icon: 'flora' },
	{
		path: '/diario-de-campo',
		label: 'Diário de campo',
		minLevel: UserHierarchyLevel.Farmer,
		icon: 'fieldDiary',
	},
	{
		path: '/produtos',
		label: 'Produtos',
		minLevel: UserHierarchyLevel.Farmer,
		icon: 'products',
	},
	{
		path: '/propriedades',
		label: 'Propriedades',
		minLevel: UserHierarchyLevel.Farmer,
		icon: 'properties',
	},
	{
		path: '/analises',
		label: 'Análises',
		minLevel: UserHierarchyLevel.Farmer,
		icon: 'microscope',
	},
	{
		path: '/recomendacoes',
		label: 'Recomendações',
		minLevel: UserHierarchyLevel.Farmer,
		icon: 'clipboard',
	},
	{ path: '/suporte', label: 'Suporte', minLevel: UserHierarchyLevel.Farmer, icon: 'contact' },
	{ path: '/meu-plano', label: 'Meu Plano', minLevel: UserHierarchyLevel.Farmer, icon: 'myPlan' },
	{
		path: '/parcelamento',
		label: 'Parcelamento',
		minLevel: UserHierarchyLevel.Farmer,
		icon: 'parcelling',
	},
	{
		path: '/perfil',
		label: 'Perfil',
		minLevel: UserHierarchyLevel.Farmer,
		icon: 'settings',
	},
];

export const CONSULTANT_ROUTES: RouteConfig[] = [
	{
		path: '/usuarios',
		label: 'Agricultores',
		minLevel: UserHierarchyLevel.Consultant,
		icon: 'farmer',
	},
];

export const COMPANY_ROUTES: RouteConfig[] = [
	{
		path: '/usuarios',
		label: 'Usuários',
		minLevel: UserHierarchyLevel.Company,
		icon: 'consultant',
	},
];

const CANONICAL_ORDER: string[] = [
	'/',
	'/dashboard',
	'/flora-ai',
	'/diario-de-campo',
	'/produtos',
	'/usuarios',
	'/propriedades',
	'/analises',
	'/recomendacoes',
	'/suporte',
	'/meu-plano',
];

export const getRoutesForLevel = (level: UserHierarchyLevel): RouteConfig[] => {
	let routes: RouteConfig[] = [];

	if (level >= UserHierarchyLevel.Farmer) {
		routes = [...routes, ...FARMER_ROUTES];
	}

	if (level >= UserHierarchyLevel.Consultant) {
		routes = [...routes, ...CONSULTANT_ROUTES];
	}

	if (level >= UserHierarchyLevel.Company) {
		routes = [...routes, ...COMPANY_ROUTES];
	}

	const seen = new Set<string>();
	const deduped = [...routes]
		.reverse()
		.filter((r) => {
			if (seen.has(r.path)) return false;
			seen.add(r.path);
			return true;
		})
		.reverse();

	return deduped.sort((a, b) => {
		const ia = CANONICAL_ORDER.indexOf(a.path);
		const ib = CANONICAL_ORDER.indexOf(b.path);
		if (ia === -1 && ib === -1) return 0;
		if (ia === -1) return 1;
		if (ib === -1) return -1;
		return ia - ib;
	});
};

export const isRouteAllowed = (path: string, level: UserHierarchyLevel): boolean => {
	const allRoutes = getRoutesForLevel(level);
	return allRoutes.some((route) => route.path === path);
};
